export default __webpack_public_path__ + "static/media/apple-icon.4cdcf41b.png";